import React, {useContext} from "react";
import { TipoControl } from "enum";
import {
	DatePicker, Form, Select, Input, TimePicker, Row, Col,
	Checkbox 
  } from "antd";
import moment from "moment";
import { SecurityContext } from "context/SecurityContextProvider";

const Control = ({ info }) => {
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
	const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;

	if (info.type === TipoControl.LISTA) {
		// Verificar si el key contiene "ListaDateTime" (no case-sensitive)
		if ((isSDF || isSDFEnergia) && info.key.toLowerCase().includes("dias-de-recuperacion")) {
			return <ListaDateTime info={info} />;
		} else if ((isSDF || isSDFEnergia) && info.key.toLowerCase().includes("cambio de turno")) {
			return <ListaCambioTurno info={info} isSDFEnergia={isSDFEnergia} />;
		}
		return <Lista info={info} />;
	} else if (info.type === TipoControl.FECHA) {
		return <Fecha info={info} />;
	} else if (info.type === TipoControl.CAJA_TEXTO) {
		return <CajaTexto info={info} />;
	}
	return null;
};

const CajaTexto = ({ info }) => {
	return (
		<Form.Item
			label={info.label}
			name={["informacionAdicional", info.key]}
			labelAlign="left"
			rules={[{ required: info.required }]}
		>
			<Input />
		</Form.Item>
	);
};

const Fecha = ({ info }) => {
	return (
		<Form.Item
			label={info.label}
			name={["informacionAdicional", info.key]}
			labelAlign="left"
			rules={[{ required: info.required }]}
		>
			<DatePicker allowClear={true} format={"DD/MM/YYYY"} style={{ width: "100%" }} />
		</Form.Item>
	);
};

const Lista = ({ info }) => {
	return (
		<Form.Item
			label={info.label}
			name={["informacionAdicional", info.key]}
			labelAlign="left"
			rules={[{ required: info.required }]}
		>
			<Select style={{ width: "100%" }}>
				{info.items !== undefined &&
					info.items.map((item) => {
						return (
							<Select.Option key={item.key} value={item.value}>
								{item.value}
							</Select.Option>
						);
					})}
			</Select>
		</Form.Item>
	);
};

const ListaDateTime = ({ info }) => {
	const form = Form.useFormInstance();
	const valorSeleccionado = Form.useWatch(["informacionAdicional", info.key], form);

	// Convertir el valor seleccionado a número
	const cantidadFilas = parseInt(valorSeleccionado) || 0;

	return (
		<>
			<Form.Item
				label={info.label}
				name={["informacionAdicional", info.key]}
				labelAlign="left"
				rules={[{ required: info.required }]}
			>
				<Select style={{ width: "100%" }}>
					{info.items !== undefined &&
						info.items.map((item) => {
							return (
								<Select.Option key={item.key} value={item.value}>
									{item.value}
								</Select.Option>
							);
						})}
				</Select>
			</Form.Item>

			{/* Crear dinámicamente las filas según la cantidad seleccionada */}
			{Array.from({ length: cantidadFilas }, (_, index) => {
				const numeroFila = index + 1;
				return (
					<Row gutter={16} key={numeroFila} style={{ marginBottom: '16px' }}>
						<Col span={8}>
							<Form.Item
								label={`Fecha-${numeroFila}`}
								name={["informacionAdicional", `Fecha-${numeroFila}`]}
								labelAlign="left"
								rules={[{ required: true, message: "Seleccione una fecha" }]}
							>
								<DatePicker 
									allowClear={true} 
									format={"DD/MM/YYYY"} 
									style={{ width: "100%" }} 
								/>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item
								label={`Hora-Inicio-${numeroFila}`}
								name={["informacionAdicional", `Hora-Inicio-${numeroFila}`]}
								labelAlign="left"
								rules={[{ required: true, message: "Seleccione hora inicio" }]}
								getValueProps={(value) => ({
									value: value ? moment(value, "HH:mm") : null,
								})}
								normalize={(value) => (value ? value.format("HH:mm") : null)}
							>
								<TimePicker 
									format={"HH:mm"} 
									style={{ width: "100%" }}
									placeholder="Seleccionar hora"
								/>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item
								label={`Hora-Fin-${numeroFila}`}
								name={["informacionAdicional", `Hora-Fin-${numeroFila}`]}
								labelAlign="left"
								rules={[{ required: true, message: "Seleccione hora fin" }]}
								getValueProps={(value) => ({
									value: value ? moment(value, "HH:mm") : null,
								})}
								normalize={(value) => (value ? value.format("HH:mm") : null)}
							>
								<TimePicker 
									format={"HH:mm"} 
									style={{ width: "100%" }}
									placeholder="Seleccionar hora"
								/>
							</Form.Item>
						</Col>
					</Row>
				);
			})}
		</>
	);
};

const TURNOS_SDF_ENERGIA = ["A", "D", "N", "P"];
const TURNOS_DEFAULT = ["1", "2", "3", "H", "N", "P", "A", "D"];

const ListaCambioTurno = ({ info, isSDFEnergia }) => {
	const form = Form.useFormInstance();
	const valorSeleccionado = Form.useWatch(["informacionAdicional", info.key], form);

	const turnos = isSDFEnergia ? TURNOS_SDF_ENERGIA : TURNOS_DEFAULT;

	return (
		<>
			<Form.Item
				label={info.label}
				name={["informacionAdicional", info.key]}
				labelAlign="left"
				rules={[{ required: info.required }]}
			>
				<Select style={{ width: "100%" }}>
					{info.items !== undefined &&
						info.items.map((item) => {
							return (
								<Select.Option key={item.key} value={item.value}>
									{item.value}
								</Select.Option>
							);
						})}
				</Select>
			</Form.Item>

			{/* Opción 1: En la Misma Fecha */}
			{valorSeleccionado === "En la Misma Fecha" && (
				<>
					<Row gutter={16}>
						<Col span={8}>
							<Form.Item
								label="Fecha de cambio"
								name={["informacionAdicional", "Fecha-Cambio"]}
								labelAlign="left"
								rules={[{ required: true, message: "Seleccione una fecha" }]}
							>
								<DatePicker
									allowClear={true}
									format={"DD/MM/YYYY"}
									style={{ width: "100%" }}
								/>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item
								label="Turno actual"
								name={["informacionAdicional", "Turno-Actual"]}
								labelAlign="left"
								rules={[{ required: true, message: "Seleccione turno actual" }]}
							>
								<Select style={{ width: "100%" }} placeholder="Seleccione turno">
									{turnos.map((t) => <Select.Option key={t} value={t}>{t}</Select.Option>)}
								</Select>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col span={8}>
							<Form.Item
								label="Turno solicitado"
								name={["informacionAdicional", "Turno-Solicitado"]}
								labelAlign="left"
								rules={[{ required: true, message: "Seleccione turno solicitado" }]}
							>
								<Select style={{ width: "100%" }} placeholder="Seleccione turno">
									{turnos.map((t) => <Select.Option key={t} value={t}>{t}</Select.Option>)}
								</Select>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item
								name={["informacionAdicional", "Pago-Segun-Rol"]}
								valuePropName="checked"
								labelAlign="left"
							>
								<Checkbox>Pago según rol</Checkbox>
							</Form.Item>
						</Col>
					</Row>
				</>
			)}

			{/* Opción 2: En Fecha distinta */}
			{valorSeleccionado === "En Fecha distinta" && (
				<>
					<Row gutter={16}>
						<Col span={8}>
							<Form.Item
								label="Trabajo el día"
								name={["informacionAdicional", "Trabajo-El-Dia"]}
								labelAlign="left"
								rules={[{ required: true, message: "Seleccione una fecha" }]}
							>
								<DatePicker
									allowClear={true}
									format={"DD/MM/YYYY"}
									style={{ width: "100%" }}
								/>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item
								label="En el turno"
								name={["informacionAdicional", "En-El-Turno-1"]}
								labelAlign="left"
								rules={[{ required: true, message: "Seleccione el turno" }]}
							>
								<Select style={{ width: "100%" }} placeholder="Seleccione turno">
									{turnos.map((t) => <Select.Option key={t} value={t}>{t}</Select.Option>)}
								</Select>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col span={8}>
							<Form.Item
								label="Por el día"
								name={["informacionAdicional", "Por-El-Dia"]}
								labelAlign="left"
								rules={[{ required: true, message: "Seleccione una fecha" }]}
							>
								<DatePicker
									allowClear={true}
									format={"DD/MM/YYYY"}
									style={{ width: "100%" }}
								/>
							</Form.Item>
						</Col>
						<Col span={8}>
							<Form.Item
								label="En el turno"
								name={["informacionAdicional", "En-El-Turno-2"]}
								labelAlign="left"
								rules={[{ required: true, message: "Seleccione el turno" }]}
							>
								<Select style={{ width: "100%" }} placeholder="Seleccione turno">
									{turnos.map((t) => <Select.Option key={t} value={t}>{t}</Select.Option>)}
								</Select>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col span={8}>
							<Form.Item
								name={["informacionAdicional", "Pago-Segun-Rol"]}
								valuePropName="checked"
								labelAlign="left"
							>
								<Checkbox>Pago según rol</Checkbox>
							</Form.Item>
						</Col>
					</Row>
				</>
			)}
		</>
	);
};
export default Control;
